
angular.module('bmsApp.state', []);
angular.module('bmsApp.state').factory('AppState', function ($http, $log, $q) {
	return {
		get: function () {
			var deferred = $q.defer();

			$http.get("api/systemState")
					.then(function (response) {
						if (response.data.success) {
							deferred.resolve(response.data);
						}
						else {
							deferred.reject(response.data.message);
						}
					}, function (error) {
						deferred.reject("A generic API error occured: " + error.data.error.message);
					});

			return deferred.promise;
		}
	}
});
